export default __webpack_public_path__ + "static/media/element_spec_38.dcee8d6e.jpg";